import React, { Component } from 'react';

/**
 * Componente ErrorBoundary para capturar erros não tratados
 * e evitar que a aplicação crash completamente
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  // Captura erros em componentes filho
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  // Log de erros e informações para debug
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log dos erros
    console.error('ErrorBoundary capturou um erro:', error, errorInfo);
  }

  // Reiniciar o estado do erro
  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    // Se ocorreu um erro, mostra uma UI de fallback
    if (this.state.hasError) {
      // Se tiver uma renderização de fallback personalizada
      if (this.props.fallback) {
        return this.props.fallback;
      }
      
      // Interface padrão de erro
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f8f9fa'
        }}>
          <h2 style={{ color: '#dc3545' }}>Algo deu errado</h2>
          <p>Ocorreu um problema ao carregar esta tela.</p>
          <button 
            onClick={() => {
              this.resetError();
              // Tentar voltar para a tela inicial
              if (window.history && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = '/';
              }
            }}
            style={{
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '20px'
            }}
          >
            Voltar para tela anterior
          </button>
        </div>
      );
    }

    // Se não há erro, renderiza normalmente os componentes filhos
    return this.props.children;
  }
}

export default ErrorBoundary; 